import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Expeditions from "./components/Expeditions";
import Missions from "./components/Missions";
import FooterCTA from "./components/FooterCTA";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Support from "./pages/Support";
import BuildFest from "./pages/BuildFest";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const Landing = () => (
  <>
    <Hero />
    <Features />
    <Expeditions />
    <Missions />
    <FooterCTA />
  </>
);

function App() {
  return (
    <div className="App bg-velis-dark min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/confidentialite" element={<Privacy />} />
          <Route path="/conditions" element={<Terms />} />
          <Route path="/support" element={<Support />} />
          <Route path="/buildfest" element={<BuildFest />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
